import React, { useState, useEffect } from "react";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Button from "../../../components/CustomButtons/Button";
import { getUser } from "../../../shared/authValidation";
import { commissionCalc } from "./CommissionLogic";
import { clone, formatDollar, formatPercentage, handleError, parseFloatString } from "../../../shared/utility";
import axios_gcib from "store/axios/axios-gcib";
import axios_gci from "store/axios/axios-gci";
import CustomRadio from "../../../components/CustomRadio/CustomRadio";

const shouldShowGCIOverride = (user) => {
    if (user) {
        if (user.permObj) {
            if (user.permObj.hasOwnProperty('Routing gci_adjustments')) {
                return true;
            }
        }
    }
    return false;
}

const GCIOverride = props => {
    const [gciOverrideData, setGCIOverrideData] = useState(null);
    const [gciEntries, setGCIEntries] = useState(null);
    const [all_commission_calculations, setAllCommissionCalculations] = useState(null);
    const [editMode, setEditMode] = useState(false);

    const { data, setData } = props;

    const findLevels = async (arr) => {
        console.log('finding levels', arr)
        try {
            for (let i = 0; i < arr.length; i++) {
                const con = arr[i];
                const contact_id = con.contact_id;
                const the_user = await axios_gcib.get('/user?contact_id='+contact_id);
                arr[i].the_user = the_user.data;
            }
            return arr;
        } catch(e) {
            handleError(e);
        }
    }

    const getGCIEntries = async () => {
        try {
            const entries = await axios_gci.get('/entries');
            setGCIEntries(entries.data);
        } catch(e) {
            handleError(e);
        }
    }

    const processIt = async () => {
        const the_all_commission_calculations = commissionCalc.calculate(data);
        console.log('all commission calculations', data);
        console.log('all_commission_calculations', the_all_commission_calculations);
        setAllCommissionCalculations(the_all_commission_calculations);
        let arr = [];
        data.commission_splits_agent2.forEach(csa => {
            arr.push({
                name: csa.Name, 
                contact_id: csa.id,
                side: 'Lessee',
                percentage: csa.Percentage,
                associate_splits: '',
                house_splits: ''
            })
        })
        data.commission_splits_agent.forEach(csa => {
            arr.push({
                name: csa.Name, 
                contact_id: csa.id,
                side: 'Lessor',
                percentage: csa.Percentage,
                associate_splits: '',
                house_splits: ''
            })
        })
        if (data.commission_splits_agent3) {
            data.commission_splits_agent3.forEach(csa => {
                arr.push({
                    name: csa.Name, 
                    contact_id: csa.id,
                    side: 'Assignor',
                    percentage: csa.Percentage,
                    associate_splits: '',
                    house_splits: ''
                })
            })
        }
        console.log('all commission calculations 2', data.id);
        const arrd = await findLevels(arr);
        setGCIOverrideData(arrd);
    }

    useEffect(() => {
        getGCIEntries();
        processIt()
    }, []);

    const user = getUser();
    console.log("GCI Override", user, props);

    const showGCIOverride = shouldShowGCIOverride(user);

    if (!showGCIOverride) return null;

    if (!data.id) return null;

    if (!all_commission_calculations) return null;

    console.log('GCIOVERRIDE DATA', gciOverrideData);

    const calculateCommissionDistribution = (acs, all_commission_calculations) => {
        let commission = 0;
        if (acs.side === 'Lessee') {
            all_commission_calculations.associate_commission_splits_lessee.forEach(csl => {
                if (csl.name === acs.name) {
                    commission = csl.value;
                }
            })
        } else if (acs.side === 'Lessor') {
            all_commission_calculations.associate_commission_splits_lessor.forEach(csl => {
                if (csl.name === acs.name) {
                    commission = csl.value;
                }
            })
        }
        return commission;
    }

    let passed = true;
    if (data.gci_overrides) {
        Object.keys(data.gci_overrides).forEach(gci => {
            const gcio = data.gci_overrides[gci];
            if (!gcio.house_splits || !gcio.associate_splits) {
                passed = false;
            }
            let house_splits = 0;
            if (gcio.house_splits) {
                house_splits = parseFloatString(gcio.house_splits);
            }
            let associate_splits = 0;
            if (gcio.associate_splits) {
                associate_splits = parseFloatString(gcio.associate_splits);
            }
            if (house_splits || associate_splits) {
                if ((house_splits + associate_splits) !== 100) {
                    passed = false;
                }
            }   
        })
    }

    console.log('GCI', gciOverrideData, data.gci_overrides, gciEntries);

    const findPercent = (level) => {
        let m = '';
        if (level) {
            if (gciEntries) {
                gciEntries.forEach(gc => {
                    if (gc.commission_level == level) {
                        const str = gc.percentage;
                        m = str.replace("%", "");
                    }
                })
            }
        }
        return m;
    }

    const content = <div>
        <h3>GCI Adjustments</h3>
        <table className="tabled">
            <thead>
                <tr>
                    <th>Associate</th>
                    <th>Side</th>
                    <th>Commission on RS %</th>
                    <th>Commission on RS $</th>
                    <th>GCI Level</th>
                    <th>Associate Split</th>
                    <th>House Split</th>
                    <th>Associate Payout</th>
                    <th>House Payout</th>
                </tr>
            </thead>
            <tbody>
                {gciOverrideData ? gciOverrideData.map((acs,x) => {
                    const id = `${acs.contact_id}_${acs.side}`;

                    const associate_splits = data.gci_overrides ?
                    data.gci_overrides[id] ? 
                        data.gci_overrides[id].associate_splits ? data.gci_overrides[id].associate_splits : ''
                    :
                        ''
                    :
                        '';
                    const house_splits = data.gci_overrides ? 
                    data.gci_overrides[id] ? 
                        data.gci_overrides[id].house_splits ? data.gci_overrides[id].house_splits : ''
                    :
                        ''
                    :
                        '';

                    const level = acs.the_user ? acs.the_user.current_commission_level : '';
                    const percent_default = findPercent(level);
                    const house_percent_default = 100 - (parseFloatString(percent_default));

                    const commission = calculateCommissionDistribution(acs, all_commission_calculations);
                    const associate_commission = associate_splits ? 
                        (parseFloatString(associate_splits) * 0.01) * commission 
                    :
                        (parseFloatString(percent_default) * 0.01) * commission;

                    const house_commission = house_splits ? 
                        (parseFloatString(house_splits) * 0.01) * commission
                    :
                        (parseFloatString(house_percent_default) * 0.01) * commission;
                    
                    return <tr key={`x-${x}`}>
                        <td>{acs.name}</td>
                        <td>{acs.side}</td>
                        <td>{formatPercentage(acs.percentage)}</td>
                        <td>{formatDollar(commission)}</td>
                        <td>{level}</td>
                        <td>
                            {editMode && <div>
                                <input type="number" style={{width:50}} value={associate_splits} onChange={(e) => {
                                    const newData = clone(data);
                                    if (!data.gci_overrides) {
                                        newData.gci_overrides = {};
                                    }
                                    if (!newData.gci_overrides[id]) {
                                        newData.gci_overrides[id] = {
                                            associate_splits: '',
                                            house_splits: ''
                                        }
                                    }
                                    newData.gci_overrides[id].associate_splits = e.target.value;
                                    setData(newData);             
                                }} /> %
                            </div>}
                            {!editMode && <div>
                                {associate_splits ? associate_splits + '%' : (percent_default + '%')}
                            </div>}
                            
                        </td>
                        <td>
                            {editMode && <div>
                                <input type="number" style={{width:50}} value={house_splits} onChange={(e) => {
                                    const newData = clone(data);
                                    if (!data.gci_overrides) {
                                        newData.gci_overrides = {};
                                    }
                                    if (!newData.gci_overrides[id]) {
                                        newData.gci_overrides[id] = {
                                            associate_splits: '',
                                            house_splits: ''
                                        }
                                    }
                                    newData.gci_overrides[id].house_splits = e.target.value;
                                    setData(newData);  
                                }} /> %
                            </div>}
                            {!editMode && <div>
                                {house_splits ? house_splits + '%' : (house_percent_default + '%')}
                            </div>}
                        </td>
                        <td>{formatDollar(associate_commission)}</td>
                        <td>{formatDollar(house_commission)}</td>
                    </tr>
                }) : null}
            </tbody>
        </table>
    </div>

    return <>
        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
                <CustomRadio
                    label="GCI Override,Yes,No"
                    options={['Yes','No']}
                    onChange={(e) => {
                        const newData = clone(data);
                        newData.is_gci_override = e.target.value;
                        if (e.target.value !== 'Yes') {
                            newData.gci_overrides = null;
                        } else {
                            newData.gci_overrides = {};
                        }
                        setData(newData);
                    }}
                    value={data.is_gci_override === 'Yes' ? 'Yes' : 'No'}
                />
                {data.is_gci_override === 'Yes' && content}

                {!passed && <div className="red-text" style={{marginTop:20}}>Invalid values, please make sure each row adds up to 100%</div>}

                {data.is_gci_override === 'Yes' && <Button
                    style={{marginTop:20}}
                    color={editMode ? 'primary' : 'rose'}
                    onClick={() => {
                        setEditMode(!editMode);
                    }}
                >{editMode ? 'EDIT MODE OFF' : 'EDIT MODE ON'}</Button>}
            </GridItem>
        </GridContainer>
    </>
}

export default GCIOverride;